import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function Relatorios() {
  const [canais, setCanais] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [filtros, setFiltros] = useState({
    canal_id: '', atendente_id: '',
    data_inicio: new Date().toISOString().slice(0,10),
    data_fim: new Date().toISOString().slice(0,10),
  });
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    api.get('/canais').then(r => setCanais(r.data));
    api.get('/usuarios').then(r => setUsuarios(r.data));
  }, []);

  const buscar = async () => {
    setCarregando(true);
    try {
      const params = new URLSearchParams();
      if (filtros.canal_id) params.append('canal_id', filtros.canal_id);
      if (filtros.atendente_id) params.append('atendente_id', filtros.atendente_id);
      if (filtros.data_inicio) params.append('data_inicio', filtros.data_inicio);
      if (filtros.data_fim) params.append('data_fim', filtros.data_fim);
      const { data } = await api.get(`/relatorios?${params}`);
      setDados(data);
    } catch { toast.error('Erro ao buscar relatório'); }
    finally { setCarregando(false); }
  };

  const exportarExcel = () => {
    if (!dados) return;
    const rows = [
      ['ID', 'Canal', 'Cliente', 'Número', 'Atendente', 'Status', 'Tipo', 'Iniciado em', 'Espera (min)', 'Duração (min)'],
      ...dados.atendimentos.map(a => [
        a.id, a.canal, a.cliente, a.numero_whatsapp, a.atendente, a.status, a.tipo,
        a.iniciado_em ? new Date(a.iniciado_em).toLocaleString('pt-BR') : '',
        a.espera_min || 0, a.duracao_min || 0
      ])
    ];
    const csv = rows.map(r => r.map(c => `"${c}"`).join(';')).join('\n');
    const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'relatorio.csv'; a.click();
  };

  const exportarPDF = () => {
    if (!dados) return;
    const win = window.open('', '_blank');
    const periodo = `${filtros.data_inicio} até ${filtros.data_fim}`;
    win.document.write(`
      <html><head><title>Relatório de Atendimentos</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; margin: 20px; }
        h1 { color: #e8500a; font-size: 18px; }
        h2 { color: #333; font-size: 14px; border-bottom: 1px solid #ddd; padding-bottom: 4px; margin-top: 20px; }
        .cards { display: flex; gap: 12px; flex-wrap: wrap; margin: 12px 0; }
        .card { background: #f5f5f5; border-radius: 6px; padding: 10px 16px; min-width: 120px; }
        .card-val { font-size: 22px; font-weight: bold; color: #e8500a; }
        .card-lbl { font-size: 11px; color: #666; }
        table { width: 100%; border-collapse: collapse; margin-top: 8px; }
        th { background: #e8500a; color: white; padding: 6px 8px; text-align: left; font-size: 11px; }
        td { padding: 5px 8px; border-bottom: 1px solid #eee; font-size: 11px; }
        tr:nth-child(even) { background: #f9f9f9; }
        .footer { margin-top: 20px; font-size: 10px; color: #999; }
      </style></head><body>
      <h1>Relatório de Atendimentos — Lojas Presidente</h1>
      <p>Período: ${periodo}</p>
      <h2>Resumo Geral</h2>
      <div class="cards">
        <div class="card"><div class="card-val">${dados.resumo.total}</div><div class="card-lbl">Total</div></div>
        <div class="card"><div class="card-val">${dados.resumo.encerrados}</div><div class="card-lbl">Encerrados</div></div>
        <div class="card"><div class="card-val">${dados.resumo.em_atendimento}</div><div class="card-lbl">Em Atendimento</div></div>
        <div class="card"><div class="card-val">${dados.resumo.aguardando}</div><div class="card-lbl">Aguardando</div></div>
        <div class="card"><div class="card-val">${dados.resumo.tempo_medio_espera_min || 0} min</div><div class="card-lbl">Espera Média</div></div>
        <div class="card"><div class="card-val">${dados.resumo.tempo_medio_atendimento_min || 0} min</div><div class="card-lbl">Duração Média</div></div>
      </div>
      <h2>Por Canal</h2>
      <table><tr><th>Canal</th><th>Total</th><th>Encerrados</th><th>Espera Média (min)</th></tr>
      ${dados.porCanal.map(r => `<tr><td>${r.canal}</td><td>${r.total}</td><td>${r.encerrados}</td><td>${r.tempo_medio_espera_min || 0}</td></tr>`).join('')}
      </table>
      <h2>Por Atendente</h2>
      <table><tr><th>Atendente</th><th>Total</th><th>Encerrados</th><th>Duração Média (min)</th></tr>
      ${dados.porAtendente.map(r => `<tr><td>${r.atendente}</td><td>${r.total}</td><td>${r.encerrados}</td><td>${r.tempo_medio_atendimento_min || 0}</td></tr>`).join('')}
      </table>
      <h2>Por Tipo de Atendimento</h2>
      <table><tr><th>Tipo</th><th>Total</th></tr>
      ${dados.porTipo.map(r => `<tr><td>${r.tipo}</td><td>${r.total}</td></tr>`).join('')}
      </table>
      <h2>Atendimentos (${dados.atendimentos.length})</h2>
      <table><tr><th>Cliente</th><th>Canal</th><th>Atendente</th><th>Tipo</th><th>Status</th><th>Data</th><th>Espera</th><th>Duração</th></tr>
      ${dados.atendimentos.map(a => `<tr>
        <td>${a.cliente}</td><td>${a.canal}</td><td>${a.atendente}</td><td>${a.tipo}</td><td>${a.status}</td>
        <td>${a.iniciado_em ? new Date(a.iniciado_em).toLocaleString('pt-BR') : ''}</td>
        <td>${a.espera_min || 0} min</td><td>${a.duracao_min || 0} min</td>
      </tr>`).join('')}
      </table>
      <div class="footer">Gerado em ${new Date().toLocaleString('pt-BR')}</div>
      </body></html>
    `);
    win.document.close();
    setTimeout(() => win.print(), 500);
  };

  const f = (v) => setFiltros(p => ({...p, ...v}));

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h2>Relatórios de Atendimento</h2>
      </div>

      <div style={{background:'var(--bg-card)',borderRadius:8,padding:16,marginBottom:20,display:'flex',gap:12,flexWrap:'wrap',alignItems:'flex-end'}}>
        <div className="form-group" style={{margin:0}}>
          <label>Canal</label>
          <select value={filtros.canal_id} onChange={e => f({canal_id: e.target.value})}>
            <option value="">Todos</option>
            {canais.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
          </select>
        </div>
        <div className="form-group" style={{margin:0}}>
          <label>Atendente</label>
          <select value={filtros.atendente_id} onChange={e => f({atendente_id: e.target.value})}>
            <option value="">Todos</option>
            {usuarios.filter(u => u.perfil === 'atendente').map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}
          </select>
        </div>
        <div className="form-group" style={{margin:0}}>
          <label>Data Início</label>
          <input type="date" value={filtros.data_inicio} onChange={e => f({data_inicio: e.target.value})} />
        </div>
        <div className="form-group" style={{margin:0}}>
          <label>Data Fim</label>
          <input type="date" value={filtros.data_fim} onChange={e => f({data_fim: e.target.value})} />
        </div>
        <button className="btn-primary" onClick={buscar} disabled={carregando}>
          {carregando ? 'Buscando...' : '🔍 Buscar'}
        </button>
        {dados && <>
          <button className="btn-secondary" onClick={exportarExcel}>📊 Exportar CSV/Excel</button>
          <button className="btn-secondary" onClick={exportarPDF}>📄 Exportar PDF</button>
        </>}
      </div>

      {dados && <>
        <div style={{display:'flex',gap:12,flexWrap:'wrap',marginBottom:20}}>
          {[
            {val: dados.resumo.total, lbl: 'Total de Atendimentos'},
            {val: dados.resumo.encerrados, lbl: 'Encerrados'},
            {val: dados.resumo.em_atendimento, lbl: 'Em Atendimento'},
            {val: dados.resumo.aguardando, lbl: 'Aguardando'},
            {val: `${dados.resumo.tempo_medio_espera_min || 0} min`, lbl: 'Espera Média'},
            {val: `${dados.resumo.tempo_medio_atendimento_min || 0} min`, lbl: 'Duração Média'},
          ].map((c,i) => (
            <div key={i} style={{background:'var(--bg-card)',borderRadius:8,padding:'12px 20px',minWidth:130,flex:1}}>
              <div style={{fontSize:28,fontWeight:700,color:'var(--orange)'}}>{c.val}</div>
              <div style={{fontSize:12,color:'var(--text-muted)',marginTop:2}}>{c.lbl}</div>
            </div>
          ))}
        </div>

        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:20}}>
          <div style={{background:'var(--bg-card)',borderRadius:8,padding:16}}>
            <h3 style={{marginBottom:12,fontSize:14}}>Por Canal</h3>
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead><tr style={{borderBottom:'1px solid var(--border)'}}>
                <th style={{textAlign:'left',padding:'4px 8px',fontSize:12}}>Canal</th>
                <th style={{textAlign:'right',padding:'4px 8px',fontSize:12}}>Total</th>
                <th style={{textAlign:'right',padding:'4px 8px',fontSize:12}}>Encerrados</th>
                <th style={{textAlign:'right',padding:'4px 8px',fontSize:12}}>Espera Média</th>
              </tr></thead>
              <tbody>{dados.porCanal.map((r,i) => (
                <tr key={i} style={{borderBottom:'1px solid var(--border)'}}>
                  <td style={{padding:'4px 8px',fontSize:12}}>{r.canal}</td>
                  <td style={{textAlign:'right',padding:'4px 8px',fontSize:12}}>{r.total}</td>
                  <td style={{textAlign:'right',padding:'4px 8px',fontSize:12}}>{r.encerrados}</td>
                  <td style={{textAlign:'right',padding:'4px 8px',fontSize:12}}>{r.tempo_medio_espera_min || 0} min</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
          <div style={{background:'var(--bg-card)',borderRadius:8,padding:16}}>
            <h3 style={{marginBottom:12,fontSize:14}}>Por Atendente</h3>
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead><tr style={{borderBottom:'1px solid var(--border)'}}>
                <th style={{textAlign:'left',padding:'4px 8px',fontSize:12}}>Atendente</th>
                <th style={{textAlign:'right',padding:'4px 8px',fontSize:12}}>Total</th>
                <th style={{textAlign:'right',padding:'4px 8px',fontSize:12}}>Encerrados</th>
                <th style={{textAlign:'right',padding:'4px 8px',fontSize:12}}>Duração Média</th>
              </tr></thead>
              <tbody>{dados.porAtendente.map((r,i) => (
                <tr key={i} style={{borderBottom:'1px solid var(--border)'}}>
                  <td style={{padding:'4px 8px',fontSize:12}}>{r.atendente}</td>
                  <td style={{textAlign:'right',padding:'4px 8px',fontSize:12}}>{r.total}</td>
                  <td style={{textAlign:'right',padding:'4px 8px',fontSize:12}}>{r.encerrados}</td>
                  <td style={{textAlign:'right',padding:'4px 8px',fontSize:12}}>{r.tempo_medio_atendimento_min || 0} min</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </div>

        <div style={{background:'var(--bg-card)',borderRadius:8,padding:16,marginBottom:20}}>
          <h3 style={{marginBottom:12,fontSize:14}}>Por Tipo de Atendimento</h3>
          <div style={{display:'flex',gap:12,flexWrap:'wrap'}}>
            {dados.porTipo.map((r,i) => (
              <div key={i} style={{background:'var(--bg-secondary)',borderRadius:6,padding:'8px 16px',display:'flex',gap:12,alignItems:'center'}}>
                <span style={{fontSize:12}}>{r.tipo}</span>
                <span style={{fontWeight:700,color:'var(--orange)'}}>{r.total}</span>
              </div>
            ))}
          </div>
        </div>

        <div style={{background:'var(--bg-card)',borderRadius:8,padding:16}}>
          <h3 style={{marginBottom:12,fontSize:14}}>Lista de Atendimentos ({dados.atendimentos.length})</h3>
          <div style={{overflowX:'auto'}}>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
              <thead><tr style={{borderBottom:'2px solid var(--border)',background:'var(--bg-secondary)'}}>
                <th style={{textAlign:'left',padding:'6px 8px'}}>Cliente</th>
                <th style={{textAlign:'left',padding:'6px 8px'}}>Canal</th>
                <th style={{textAlign:'left',padding:'6px 8px'}}>Atendente</th>
                <th style={{textAlign:'left',padding:'6px 8px'}}>Tipo</th>
                <th style={{textAlign:'left',padding:'6px 8px'}}>Status</th>
                <th style={{textAlign:'left',padding:'6px 8px'}}>Data</th>
                <th style={{textAlign:'right',padding:'6px 8px'}}>Espera</th>
                <th style={{textAlign:'right',padding:'6px 8px'}}>Duração</th>
              </tr></thead>
              <tbody>{dados.atendimentos.map((a,i) => (
                <tr key={i} style={{borderBottom:'1px solid var(--border)'}}>
                  <td style={{padding:'5px 8px'}}>{a.cliente}</td>
                  <td style={{padding:'5px 8px'}}>{a.canal}</td>
                  <td style={{padding:'5px 8px'}}>{a.atendente}</td>
                  <td style={{padding:'5px 8px'}}>{a.tipo}</td>
                  <td style={{padding:'5px 8px'}}>
                    <span style={{padding:'2px 8px',borderRadius:10,fontSize:11,
                      background: a.status==='encerrado' ? '#e5e7eb' : a.status==='em_atendimento' ? '#dcfce7' : '#fef3c7',
                      color: a.status==='encerrado' ? '#6b7280' : a.status==='em_atendimento' ? '#16a34a' : '#92400e'
                    }}>{a.status}</span>
                  </td>
                  <td style={{padding:'5px 8px'}}>{a.iniciado_em ? new Date(a.iniciado_em).toLocaleString('pt-BR') : '-'}</td>
                  <td style={{textAlign:'right',padding:'5px 8px'}}>{a.espera_min || 0} min</td>
                  <td style={{textAlign:'right',padding:'5px 8px'}}>{a.duracao_min || 0} min</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </div>
      </>}

      {!dados && !carregando && (
        <div style={{textAlign:'center',padding:'60px 0',color:'var(--text-muted)'}}>
          <div style={{fontSize:48,marginBottom:12}}>📊</div>
          <p>Selecione os filtros e clique em Buscar para gerar o relatório</p>
        </div>
      )}
    </div>
  );
}
